import { useFetch } from '../query/reactQuery';
import { urlsApi } from "./urls/apiUrl";

export const useGetTypeUser = (data: any, enabled: boolean) =>
  useFetch<any>(urlsApi.user.checkTypeUser+ '/' + data?.user_uuid, {}, {enabled: !!data?.user_uuid && enabled});

export const useGetNumberViewMessage = (enabled: boolean) =>
  useFetch<any>(urlsApi.messaging.view_number_message, {}, { enabled }, process.env.REACT_APP_MESSAGING_BACK_URL);